import React, { useEffect, useState, useMemo } from "react";
import '../Home/Home.css';
import SelectableBlockTicket from "../SelectableBlockTicket/SelectableBlockTicket";
import { useSelection } from "../../SelectionContext";
import { useNavigation } from "../../NavigationContext";
import Translate from "../../Translate";
import { FaPlus } from "react-icons/fa";
import CustomSVG from "../CustomSVG/CustomSVG";

import { FaMinus } from "react-icons/fa6";

export default function TicketSelection({ selectedCity }) {
    const { selection, updateSelection } = useSelection({ tickets: {} });
    const { setNextEnabled } = useNavigation();

    const ticketOptions = useMemo(() => {
        switch (selectedCity) {
            case "Tallinn":
                return [
                    { id: "standard", title: <Translate id="StandardTicket" />, titleAdditional: <Translate id="StandardTicketDescription"/>, price: 10 },
                    { id: "discounted", title: <Translate id="DiscountedTicket" />,titleAdditional: <Translate id="DiscountedTicketDescription"/>, price: 25 },
                    { id: "family", title: <Translate id="FamilyTicket" />,titleAdditional: <Translate id="FamilyTicketDescription"/>, price: 40 },
                    { id: "group", title: <Translate id="GroupTicket" />,titleAdditional: <Translate id="GroupTicketDescription"/>, price: 40 },
                    { id: "school", title: <Translate id="SchoolTicket" />,titleAdditional: <Translate id="SchoolTicketDescription"/>, price: 40 },
                    { id: "gift", title: <Translate id="GiftCard" />,titleAdditional: <Translate id="GiftCardDescription"/>, price: 40 },
                    { id: "museum", title: <Translate id="MuseumCard" />,titleAdditional: <Translate id="MuseumCardDescription"/>, price: 40 },
                    { id: "tallinnCard", title: <Translate id="TallinnCard" />,titleAdditional: <Translate id="TallinnCardDescription"/>, price: 40 },

                ];
            case "Tartu":
                return [
                    { id: "standard", title: <Translate id="StandardTicket" />, titleAdditional: <Translate id="StandardTicketDescription"/>, price: 10 },
                    { id: "discounted", title: <Translate id="DiscountedTicket" />,titleAdditional: <Translate id="DiscountedTicketDescription"/>, price: 25 },
                    { id: "family", title: <Translate id="FamilyTicket" />,titleAdditional: <Translate id="FamilyTicketDescription"/>, price: 40 },
                    { id: "group", title: <Translate id="GroupTicket" />,titleAdditional: <Translate id="GroupTicketDescription"/>, price: 40 },
                    { id: "school", title: <Translate id="SchoolTicket" />,titleAdditional: <Translate id="SchoolTicketDescription"/>, price: 40 },
                    { id: "gift", title: <Translate id="GiftCard" />,titleAdditional: <Translate id="GiftCardDescription"/>, price: 40 },
                    { id: "museum", title: <Translate id="MuseumCard" />,titleAdditional: <Translate id="MuseumCardDescription"/>, price: 40 },
                    { id: "tallinnCard", title: <Translate id="TallinnCard" />,titleAdditional: <Translate id="TallinnCardDescription"/>, price: 40 },

                ];
            case "Toila":
                return [
                    { id: "standard", title: <Translate id="StandardTicket" />, titleAdditional: <Translate id="StandardTicketDescription"/>, price: 10 },
                    { id: "discounted", title: <Translate id="DiscountedTicket" />,titleAdditional: <Translate id="DiscountedTicketDescription"/>, price: 25 },
                    { id: "family", title: <Translate id="FamilyTicket" />,titleAdditional: <Translate id="FamilyTicketDescription"/>, price: 40 },
                    { id: "group", title: <Translate id="GroupTicket" />,titleAdditional: <Translate id="GroupTicketDescription"/>, price: 40 },
                    { id: "school", title: <Translate id="SchoolTicket" />,titleAdditional: <Translate id="SchoolTicketDescription"/>, price: 40 },
                    { id: "gift", title: <Translate id="GiftCard" />,titleAdditional: <Translate id="GiftCardDescription"/>, price: 40 },
                    { id: "museum", title: <Translate id="MuseumCard" />,titleAdditional: <Translate id="MuseumCardDescription"/>, price: 40 },
                    { id: "tallinnCard", title: <Translate id="TallinnCard" />,titleAdditional: <Translate id="TallinnCardDescription"/>, price: 40 },

                ];
            default:
                return [];
        }
    }, [selectedCity]);

    const handleTicketChange = (ticketId, change) => {
        const currentTickets = selection.tickets || {};
        updateSelection("tickets", {
            ...currentTickets,
            [ticketId]: Math.max(0, (currentTickets[ticketId] || 0) + change)
        });
    };

    const totalPrice = useMemo(() => {
        const tickets = selection.tickets || {};
        return ticketOptions.reduce((sum, ticket) => {
            return sum + (tickets[ticket.id] || 0) * ticket.price;
        }, 0);
    }, [selection.tickets, ticketOptions]);
    console.log(selection)

    useEffect(() => {
        const tickets = selection.tickets || {};
        setNextEnabled(Object.values(tickets).some(count => count > 0));
    }, [selection.tickets, setNextEnabled]);

    return (
        <div className="home-container">
            <div className="ticket-container">
                <div className="blocks-container">
                    {ticketOptions.map((ticket) => (
                        <div key={ticket.id} className="ticket-block">
                            <SelectableBlockTicket
                                title={ticket.title}
                                titleAdditional={ticket.titleAdditional}
                                price={ticket.price}
                                isSelected={(selection.tickets || {})[ticket.id] > 0}
                                onSelect={() => handleTicketChange(ticket.id, 1)}
                            />
                            {(selection.tickets || {})[ticket.id] > 0 && (
                                <div className="ticket-counter">
                                    <button onClick={() => handleTicketChange(ticket.id, -1)}><FaMinus /></button>
                                    <span>{(selection.tickets || {})[ticket.id]}</span>
                                    <button onClick={() => handleTicketChange(ticket.id, 1)}><FaPlus /></button>
                                    <span>{ticket.price * (selection.tickets || {})[ticket.id]}€</span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            {totalPrice > 0 && (
                <div className="total-price">
                    <p><Translate id="TotalPrice" />: <strong>{totalPrice}€</strong></p>
                </div>
            )}
            <div className="slider__controls">
                    <button
                        // onClick={prevSlide}
                        style={{
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            // visibility: currentIndex === 0 ? 'hidden' : 'visible',
                            }}
                    >
                        <CustomSVG  fillColor="#f6b5d3" ><Translate id="BackButton"/></CustomSVG>
                    </button>
                    <button
                        // onClick={nextSlide}
                        style={{
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            // visibility: isNextEnabled ? "visible" : "hidden"
                        }}
                    >
                        <CustomSVG fillColor="#f6b5d3" flipped={true}><Translate id="NextButton" /></CustomSVG>
                    </button>

                </div>
        </div>
    );
}